"use strict";

Shopify.theme.jsAnnouncementSlider = {
    init: function init($section) {
        Shopify.theme.jsAnnouncementSlider = $.extend(this, Shopify.theme.getSectionData($section));

        let $ann_fade = null
        $section.removeClass('is-hidden')
        let $slideshowClassicEl = $section.find('.announcement-slider');
        let $slider = {}
        let _this1 = this;
        if ($slideshowClassicEl.hasClass('has-fade-ineffect')) {
            $ann_fade = $slideshowClassicEl;
            var count = 1;
            var maxCount = $ann_fade.find('.fadeInAimate').length;
            textAnimate(count, maxCount);


            function textAnimate(count, maxCount) {
                $ann_fade.find('.fadeInAimate').eq(count - 1).animate({
                    opacity: '0'
                }, {
                    duration: 900,
                    queue: false
                }).hide();

                count++;
                if (count > maxCount) {
                    count = 1;
                }

                $ann_fade.find('.fadeInAimate').eq(count - 1).show().animate({
                    opacity: '1'
                }, {
                    duration: 900,
                    queue: false
                });

                window.setTimeout(function() {
                    textAnimate(count, maxCount)
                }, 3000);
            }


        } else {
            $slider = $slideshowClassicEl.flickity({
                autoPlay: _this1.autoplay_speed,
                prevNextButtons: true,
                pageDots: false,
                draggable: true,
                wrapAround: true,
                align:'center',
                arrowShape: 'M22.6401 11L27.6022 15.9621M27.6022 15.9621L22.6401 20.9241M27.6022 15.9621H3'
            });
        }
    },
    blockSelect: function blockSelect($section, blockId) {

        //     console.log(blockId)
        //     var $slider = $section.find('.announcement-slider');
        //     var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
        //     flickity.flickity('select', $sliderIndex, true, true);
    },
    unload: function unload($section) {}
};